// Parques temáticos (categoría 4): los resultados tienen el mismo formato que alojamiento,
// con las habitaciones ordenadas por precio, así que la tarjeta usa la primera.
export function getParkPrice(product: any): number {
  const room = product?.additionalInfo?.rooms?.[0]?.room;
  return (Number(room?.optionNightsNetTotalProf) || 0) + (Number(room?.pricing?.taxesExcluded) || 0);
}

export function getParkCurrency(product: any): string {
  return product?.additionalInfo?.rooms?.[0]?.room?.pricing?.currency;
}
